<div class="p-2">
  <ejs-tab class="mt-2"
           [animation]="animation"
           heightAdjustMode="fill">
    <e-tabitems>
      <e-tabitem>
        <ng-template #headerText>
          {{'i18n.domain.administration.subscription-details.general' | translate}}
              <span class="icon-warning--alt text-warning ms-2"
                    *ngIf="subscriptionForm.invalid"></span>
        </ng-template>
        <ng-template #content>
          <div class="form-row row px-2" [hidden]="!isUsedInSessions">
            <div class="col-6">
              <div appMessageDirective [variant]="MessageVariant.Standart" [severity]="MessageSeverity.AVPColors">{{'i18n.domain.administration.subscription-details.general-tab.has-active-sessions-hint' | translate}}</div>
            </div>
          </div>
          <div class="form-row row">
            <div class="col-12">
              <app-subscription-details-general [subscriptionForm]="subscriptionForm"></app-subscription-details-general>
            </div>
          </div>
        </ng-template>
      </e-tabitem>
      <e-tabitem [visible]="!isAddSubscription">
        <ng-template #headerText>
          {{'i18n.domain.administration.subscription-details.tariffs' | translate}}
        </ng-template>
        <ng-template #content>
          <app-subscription-details-tariffs [assignedTariffs]="selectedSubscription?.tariffs"></app-subscription-details-tariffs>
        </ng-template>
      </e-tabitem>
    </e-tabitems>
  </ejs-tab>
  <div class="detail-footer p-2 pt-3">
    <button type="button"
            class="btn btn-danger me-auto"
            (click)="deleteSubscription()"
            *ngIf="selectedSubscription"
            [disabled]="!canDelete || isReadonly">
      {{'i18n.domain.administration.subscription-details.messages.delete-title' | translate}}
    </button>
    <button type="button"
            class="btn btn-secondary me-2"
            (click)="onCancelClicked()"
            [disabled]="isBusy">
      {{cancelButtonText | translate}}
    </button>
    <button type="button"
            class="btn btn-primary"
            (click)="submitForm()"
            [disabled]="saveButtonDisabled || isBusy || isReadonly">
      {{'i18n.shared.save' | translate}}
    </button>
  </div>
</div>
